'use client'

import * as Sentry from '@sentry/nextjs'
import NextError from 'next/error'
import { useEffect } from 'react'

export default function GlobalError({ error }) {
  useEffect(() => {
    console.log('capturing global error', error)
    Sentry.captureException(error)
  }, [error])

  return (
    <html>
      <body>
        <NextError />
      </body>
    </html>
  )
}
